module.exports = __webpack_public_path__ + "img/maxx-icon.b9146d8b.png";